/**
 *
 * @param designer
 * @param sourceId
 */
export function triggerSourceUpdate(designer, sourceId) {
  if (designer.rootPagelet) {
    // 强制触发pagelet json更新， dark magic from ly
    designer.rootPagelet = {
      ...designer.rootPagelet
    };
  }
  const sourceController = designer.rootRenderer.sources[sourceId];
  if (sourceController) {
    // schema变了，触发下左侧面板更新
    sourceController.$emit('load-schema', sourceController);
  }
}
//# sourceMappingURL=triggerSourceUpdate.js.map
